import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { typify } from '../../common';
import { ReadSettlementConfigurationDto } from '../generated-dto';
export class SettlementConfigurationResponse {
}
__decorate([
    ApiProperty({ type: typify(Boolean), description: 'Is square checking account enabled or not' }),
    __metadata("design:type", Boolean)
], SettlementConfigurationResponse.prototype, "isSQCheckingAccountEnabled", void 0);
__decorate([
    ApiProperty({ type: typify(ReadSettlementConfigurationDto) }),
    __metadata("design:type", ReadSettlementConfigurationDto)
], SettlementConfigurationResponse.prototype, "settlementConfiguration", void 0);
//# sourceMappingURL=SettlementConfigurationResponse.js.map